export const GAME_STATUS = {
  open: 0,
  locked: 1,
  complete: 2,
  expired: 3,
}

export const GAME_COLORS = ['red', 'green', 'blue', 'yellow']

export const COLOR_HEXCODES = {
  red: '#cd412b',
  green: '#aade4e',
  blue: '#3f99d7',
  yellow: '#f1c40f',
}
